<template>
    <div id="content">
        <div class="page">
            <div class="header">
                <h1>{{ $t('login.title') }}</h1>
                <p>{{ $t('login.intro') }}</p>
            </div>

            <form action="#">
                <label for="email">{{ $t('login.form.email') }}</label>
                <input type="email" id="email" v-model="form.emailAddress" required>
                <br><br>

                <label for="password">{{ $t('login.form.password') }}</label>
                <input type="password" id="password" v-model="form.password" required>
                <br><br>

                <button type="submit" @click="login()">{{ $t('action.login') }}</button>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: {
                    emailAddress: null,
                    password: null
                }
            };
        },
        mounted() {
            let localAuth = localStorage.getItem("auth");
            if(localAuth) {
                this.$store.state.auth = JSON.parse(localAuth);
                this.setLanguage();
            }
        },
        methods: {
            async login() {
                this.$store.state.auth = await this.request("PUT", "login", this.form);

                // Put auth details into localstorage for next sessions
                localStorage.setItem("auth", JSON.stringify({
                    id: this.$store.state.auth.id,
                    firstName: this.$store.state.auth.firstName,
                    emailAddress: this.$store.state.auth.emailAddress,
                    token: this.$store.state.auth.token,
                    language: this.$store.state.auth.language
                }));
                this.setLanguage();
            },
            setLanguage() {
                this.$i18n.locale = this.$store.state.auth.language.toLowerCase();
            }
        }
    }
</script>
<style scoped lang="less" src="@/assets/login.less"></style>